<button
  aria-label="toggle sidebar"
  class="no-style burger-wrapper"
  (click)="onSidebarToggle()">
  <div
    class="menu-burger"
    id="menu-bar-close-open">
    @if (isSidebarVisible()) {
      <mat-icon
        animate.enter="fade-in"
        animate.leave="fade-out">
        close
      </mat-icon>
    }
    @if (!isSidebarVisible()) {
      <mat-icon
        animate.enter="fade-in"
        animate.leave="fade-out">
        menu
      </mat-icon>
    }
  </div>
</button>
<customer-app-collapsed-bar
  role="menu"
  [titles]="titles()"
  (toggleItem)="onSidebarToggle($event)"></customer-app-collapsed-bar>
<div
  class="components"
  role="menu">
  <ng-content></ng-content>
</div>
